import React, { useMemo } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import { Breadcrumb, Icon } from "../../ui";
import { cn } from "@/lib/utils";
import {
  metaAdsGradientCardEdgeClass,
  metaAdsOutlineCtaClass,
  metaAdsPrimaryButtonClass,
} from "./metaAdsTheme";

const MetaAdsCampaignSubmittedPage = () => {
  const { t } = useTranslation("metaAds");
  const { t: tNav } = useTranslation("navigation");
  const navigate = useNavigate();
  const location = useLocation();
  const campaignName = location.state?.campaignName;

  const breadcrumbItems = useMemo(
    () => [
      { label: tNav("sidebar.growth"), disabled: true },
      {
        label: tNav("sidebar.metaAds"),
        path: "/growth/meta-ads",
        icon: "Share2",
      },
      {
        label: t("success.title"),
        active: true,
        disabled: true,
      },
    ],
    [t, tNav],
  );

  return (
    <div
      className={cn(
        "flex min-h-[calc(100dvh-5.5rem)] flex-col",
        "sm:min-h-[calc(100dvh-6rem)]",
      )}
    >
      <div className="shrink-0">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      <div className="flex flex-1 flex-col justify-center py-6 sm:py-8">
        <div className="mx-auto flex w-full max-w-xl flex-col gap-6">
          <div className={metaAdsGradientCardEdgeClass}>
            <div
              className={cn(
                "bg-card text-card-foreground relative overflow-hidden rounded-2xl p-6 sm:p-8",
              )}
            >
              <div className="relative z-[1] flex flex-col items-center text-center">
                <div
                  className={cn(
                    "mb-4 flex h-12 w-12 items-center justify-center rounded-xl",
                    "border-success/40 bg-success/10 text-success border",
                  )}
                >
                  <Icon
                    name="Check"
                    className="h-6 w-6"
                    strokeWidth={2.5}
                    aria-hidden
                  />
                </div>
                <h1 className="text-xl font-bold sm:text-2xl">
                  {t("success.headline")}
                </h1>
                <p className="text-muted-foreground mt-3 text-sm leading-relaxed sm:text-base">
                  {t("success.body")}
                </p>
                {campaignName ? (
                  <p className="text-foreground/95 mt-2 text-sm">
                    <Trans
                      i18nKey="metaAds:success.campaignLine"
                      values={{ name: campaignName }}
                      components={[
                        <span className="text-muted-foreground" key="label" />,
                        <span
                          className="text-foreground font-semibold"
                          key="name"
                        />,
                      ]}
                    />
                  </p>
                ) : null}

                <div className="mt-8 flex w-full flex-col gap-3 sm:flex-row sm:justify-center">
                  <button
                    type="button"
                    onClick={() => navigate("/growth/meta-ads/performance")}
                    className={cn(
                      "flex h-12 flex-1 items-center justify-center gap-2 px-4",
                      "sm:min-w-[10rem] sm:flex-none",
                      metaAdsPrimaryButtonClass,
                    )}
                  >
                    {t("success.viewPerformance")}
                    <Icon name="BarChart3" className="h-5 w-5" aria-hidden />
                  </button>
                  <Link
                    to="/growth/meta-ads"
                    className={cn(
                      "inline-flex h-12 flex-1 items-center justify-center px-4",
                      "sm:min-w-[10rem] sm:flex-none",
                      metaAdsOutlineCtaClass,
                    )}
                  >
                    {t("success.backHub")}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetaAdsCampaignSubmittedPage;
